import {
  whiteColor,
  oceanBlueColor,
  DodgerBlueColor,
} from "../../cmsMainStyle";

const dpsDetailFormStyle = (theme) => ({
  appbarTest: {
    color: oceanBlueColor[9],
    fontStyle: "italic",
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  panel: {
    backgroundColor: "white",
  },
  editSection: {
    padding: "10px",
    backgroundColor: "white",
  },
  divider: {
    marginBottom: theme.spacing(1),
    borderColor: oceanBlueColor[7],
  },
  itemHeader: {
    fontWeight: "bold",
  },
  itemText: {
    display: "inline",
    fontWeight: "normal",
    color: oceanBlueColor[7],
  },
  contentHeader: {
    textAlign: "center",
    fontWeight: "bold",
    borderBottom: "1px solid black",
  },
  contentBorder: {
    border: "1px solid black",
  },
  pasEditHeader: {
    marginTop: theme.spacing(1),
    fontStyle: "italic",
    textAlign: "center",
  },
  btnClass: {
    display: "flex",
    justifyContent: "center",

    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
});

export { dpsDetailFormStyle };
